import {OpenChat} from "../model2/chat/chat/const";
import CustomView from "../model2/custom-view/custom-view"
import NavigationSection from "../model2/navigation/navigation-section";
import {SettingsSection} from "../../app/settings/@const";
import ProjectSession from "../model2/project/project-session";
import asyncSessionLoader from "./data/async-session-loader";
import {ReportConfig} from "../model2/report/@types";
import reportFactory from "../model2/report/factory";
import AppLoader_Report from "../../item-view/report/app-loader";
import {GoToOptions} from "../../../app/web/gd/gd";
import {RequestFormSubview} from "../gd-modules/request-form/@const"

// const debug = "gd.navigation"
const debug = false

export default class Navigation {

    constructor() {


    }

    goBack() {
        gd.router.history.history.state ? gd.router.history.history.back() : this.goTo('');
    }

    // sameUrlIgnore:boolean=false, options?:GoToOptions
    goTo(url:string, options?:GoToOptions) {
        debug && console.log(debug, "goto", url, "currentPath=", gd.router.history.fragment , "options=", options)

        if (options?.sameUrlIgnore) {
            if (url === gd.router.history.fragment) {
                debug && console.log(debug, "ignore go to")
                return
            }

            // this is a patch for apps that do modify they url i.e. my-work becomes my-work/spli
            const currentApp : any = gd.getMainApp()
            if (currentApp && currentApp.baseUrl && currentApp.baseUrl === url) {
                debug && console.log(debug, "ignore go to based on app.baseUrl")
                return
            }
        }

        gd.goTo(url);
    }

    goToHome() {
        this.goTo('')
    }

    goToDocument(documentId:ID) {
        this.goTo(`n/${documentId}`)
    }

    goToGoal(goalId:ID) {
        this.goTo(`goal/${goalId}`)
    }

    goToGoalInfo(goalId:ID, sectionId?: ID) {
        this.goTo('goal/{0}/info{1}'.f(goalId, sectionId ? '/{0}'.f(sectionId) : ''))
    }

    goToHistory(resourceId: RID) {
        this.goTo(`history/${resourceId}`)
    }

    /*goToForced(url:string, options:any={}) {

        gd.appManager.destroyApp()

        gd.goTo(url, options)
    }*/

    goToDashboard(customViewId:ID) {
        this.goTo('v/dashboard/'+customViewId);
    }

    goToTimeReport(timeReportId:ID) {
        this.goTo('time-report/'+timeReportId);
    }

    goToTask(taskId:ID, messageId?:ID) {
        this.goTo('t/'+taskId+(messageId ? '/'+messageId : ''));
    }

    goToExpense(expenseId:ID) {
        this.goTo('expense/'+expenseId)
    }

    goToEvent(eventId:ID) {
        this.goTo('event/'+eventId);
    }

    goToCrmContact(crmContactId:ID) {
        gd.goTo('crm/contact/'+crmContactId)
    }

    goToChat(chatId:ID) {
        const openChat = gd.user.settings.views.chat.openChatMenu
        this.goTo(`${openChat === OpenChat.WINDOW ? "c/" : "chat/"}`+chatId);
    }

    goToChatInternal(chatId:ID) {
        // const openChat = gd.user.settings.views.chat.openChatMenu
        this.goTo(`chat/${chatId}?internalLink=true`);
    }



    goToMeeting(meetingId:ID) {
        this.goTo('m/'+meetingId);
    }

    goToReminder(reminderId:ID) {
        this.goTo('reminder/'+reminderId);
    }

    goToProject(projectId:ID, path:string='') {
        this.goTo('p/'+projectId + path);
    }

    goToForm(projectId:ID, formId: ID, formSubview?: RequestFormSubview) {
        let subview = ''
        switch (formSubview) {
            case RequestFormSubview.SETTINGS:
                subview = '/settings'
                break

            case RequestFormSubview.SUBMISSIONS:
                subview = '/submissions'
                break
        }
        this.goTo('p/{0}/form/{1}{2}'.f(projectId, formId, subview));
    }

    goToUpgrade(feature:any=null) {
        gd.tempParamsStorage.set('upgrade-feature', feature)
        // @ts-ignore
        // window.upgradeFeature = feature
        gd.goTo('o/'+gd.company.id+'/upgrade')
    }

    goToCompanyUser(companyUserId: ID) {
        this.goTo('u/{0}'.f(companyUserId))
    }

    goToUserInfo(userId:ID) {
        this.goTo('u/{0}-{1}/info'.f(gd.companyId, userId))
    }

    goToGanttSnapshot(snapshotId:ID) {
        this.goTo('iv/snapshot/'+snapshotId)
    }

    goToOfficeLocations() {
        this.goTo('settings/offices')
    }

    goToNavigationPanel() {
        this.goTo('settings/navigation-panel')
    }

    goToCustomView(customView: CustomView) {
        this.goTo(customView.url)
    }

    goToWorkspace(workspaceId:ID) {
        // const section : NavigationSection = gd.navigationStructure.get("workspace-"+workspaceId)
        // gd.layout.navigation.openSectionV2(section)

        this.goTo('p/'+workspaceId)
    }
}
